import { render, staticRenderFns } from "./AccordionStepper.vue?vue&type=template&id=dbb20bfc&"
import script from "./AccordionStepper.vue?vue&type=script&lang=js&"
export * from "./AccordionStepper.vue?vue&type=script&lang=js&"
import style0 from "./AccordionStepper.vue?vue&type=style&index=0&id=dbb20bfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports